export default "__VITE_ASSET__DJ2L6xiU__"